const revenueTypes = {
  services: { id: 'services', name: 'Services' },
  expenses: { id: 'expenses', name: 'Expenses' },
  products: { id: 'products', name: 'Products' },
  other_items: { id: 'other_items', name: 'Other Items' },
};

export default revenueTypes;
